// an apiClient wrapper for endpoints that do not require authentication or tenant selection

export function createPublicApi(apiClient) {
  return function publicApi(path, options = {}) {
    return apiClient(path, {
      headers: {}, // extract headers if given. otherwise use empty object
      query: {}, // extract query params if given. otherwise use empty object
      method: "GET", // default to GET method if not set
      ...options, // spread other options
      requireAuth: false, // explicitly set to false (override any given option)
      requireTenant: false, // explicitly set to false (override any given option)
    });
  };
}